export interface FirmTile {
  id: string;
  name: string;
  logoPath: string;
}

export interface MeResponse {
  username: string;
  userName: string;
  userRole: string;
  firms: FirmTile[];
}

export class ApiError extends Error {
  constructor(
    message: string,
    public readonly status: number,
  ) {
    super(message);
    this.name = "ApiError";
  }
}

async function parseJsonOrThrow<T>(response: Response): Promise<T> {
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    const message = typeof body?.error === "string" ? body.error : "Unerwarteter Fehler";
    throw new ApiError(message, response.status);
  }
  return body as T;
}

export async function login(username: string, password: string): Promise<void> {
  const response = await fetch("/api/login", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "same-origin",
    body: JSON.stringify({ username, password }),
  });
  await parseJsonOrThrow<{ success: true }>(response);
}

export async function fetchMe(): Promise<MeResponse> {
  const response = await fetch("/api/me", { credentials: "same-origin" });
  return parseJsonOrThrow<MeResponse>(response);
}

export async function logout(): Promise<void> {
  const response = await fetch("/api/logout", {
    method: "POST",
    credentials: "same-origin",
  });
  await parseJsonOrThrow<{ success: true }>(response);
}
